/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import Card from "./MocoCard";
import Table from "./MocoTable";

const TableCard = (props) => {
  const { options, content, state, functions } = props;
  return (
    <Card
      {...content}
      options={{
        dataSource: options.dataSource,
        columns: options.columns,
      }}
      className="TableCard"
    >
      <Table {...options} {...state} {...functions} />
    </Card>
  );
};

// Declare data type for TableCard props
TableCard.propTypes = {
  content: PropTypes.object,
  options: PropTypes.shape({
    dataSource: PropTypes.array,
    columns: PropTypes.array,
  }),
  functions: PropTypes.object,
  state: PropTypes.object,
};

export default TableCard;
